import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedZorroModule } from '../shared-zorro.module';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RouterModule, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { UserService } from '../service/user.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, SharedZorroModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.less',
})
export class LoginComponent {
  loginForm!: FormGroup;
  activeTab: string = 'login';

  constructor(private fb: FormBuilder, private router: Router, private userService: UserService, private message: NzMessageService) {}

  ngOnInit() {
    this.loginForm = this.fb.group({
      username: [null, [Validators.required]],
      password: [null, [Validators.required]],
      rememberMe: [false],
    });
    this.loadPassword();
  }

  //加载记住的密码
  loadPassword() {
    let loginForm = JSON.parse(localStorage.getItem('loginForm') || '{}');
    this.loginForm.patchValue(loginForm);
  }

  onSubmit() {
    //判断表单是否有效
    if (this.loginForm.valid) {
      this.userService.login(this.loginForm.value).subscribe((res) => {
        if (res.code === 0) {
          //登录成功
          this.message.success('登录成功');
          sessionStorage.setItem('token', res.data);
          this.userService.getUserInfo().subscribe((res) => {
            sessionStorage.setItem('user', JSON.stringify(res.data));
            sessionStorage.setItem('role', JSON.stringify(res.data.roles[0]));
            this.router.navigate(['/admin/dashboard']);
          });
          if (this.loginForm.value.rememberMe) {
            this.savePassword(this.loginForm.value);
          } else {
            localStorage.removeItem('loginForm');
          }
        } else {
          this.message.error(res.msg);
        }
      });
    }
  }

  //记住密码
  savePassword(loginForm: any) {
    localStorage.setItem('loginForm', JSON.stringify(loginForm));
  }
}
